const brl = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 0,
});

const brlWithCents = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export function formatCents(cents: number): string {
  return brl.format(cents / 100);
}

export function formatCentsWithDecimals(cents: number): string {
  return brlWithCents.format(cents / 100);
}

/** Parse "R$ 3.500,00" or "3500,50" or "3500" into integer cents. Returns null on garbage. */
export function parseCentsFromBrl(raw: string): number | null {
  const cleaned = raw.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
  const value = parseFloat(cleaned);
  if (!Number.isFinite(value) || value < 0) return null;
  return Math.round(value * 100);
}
